import type React from 'react';
import { Fragment } from 'react';

import type { UseFormRegisterReturn } from 'react-hook-form';
import { IconDirDown } from '../Icon';
import InputError from '../InputError';
import InputHelp from '../InputHelp';
import { Icon, Label, Option, Select, Wrapper } from './wrapper';

export interface OptionProps {
  value?: number | string;
  displayName?: number | string | null;
  indent?: number;
  disabled?: boolean;
}

export interface Props {
  value?: string | number;
  defaultValue?: string | number;
  options?: OptionProps[];
  defaultOption?: OptionProps;
  unit?: string;
  id?: string;
  name?: string;
  title: string;
  label?: string | React.ReactNode;
  disabled?: boolean;
  help?: string;
  error?: string;
  register?: UseFormRegisterReturn;
  onChange?: (e: React.ChangeEvent<HTMLSelectElement>) => void;
}

const InputSelect = ({
  disabled,
  value,
  defaultValue,
  options,
  unit,
  id,
  name,
  title,
  label,
  defaultOption,
  help,
  error,
  register,
  onChange,
}: Props) => (
  <>
    <Wrapper $error={!!error} $disabled={disabled}>
      {label && <Label>{label}</Label>}
      <Select
        disabled={disabled}
        value={value}
        onChange={onChange}
        title={title}
        aria-label={title}
        id={id}
        name={name}
        defaultValue={defaultValue}
        {...register}
      >
        {defaultOption && (
          <Option
            key={defaultOption.value}
            value={defaultOption.value}
            disabled={defaultOption.disabled}
          >
            {defaultOption.displayName}
          </Option>
        )}
        {options?.map((option, index) => (
          <Option
            key={`${option.value}-${option.displayName ?? option.value}-${index}`}
            value={option.value ?? ''}
            disabled={option.disabled}
          >
            {option.indent !== undefined &&
              [...Array(option.indent * 4)].map((index) => <Fragment key={index}>&nbsp;</Fragment>)}
            {option.displayName || option.value}
            {unit ? ` ${unit}` : ''}
          </Option>
        ))}
      </Select>
      <Icon>
        <IconDirDown />
      </Icon>
    </Wrapper>
    {help && <InputHelp disabled={disabled}>{help}</InputHelp>}
    {error && <InputError>{error}</InputError>}
  </>
);

export default InputSelect;
